module.exports = __webpack_public_path__ + "static/img/jych.8fca35f7.png";